<template>
  <div class="app-wrapper">
    <!-- 独立的安卓状态栏颜色承载层 -->
    <div class="native-status-bar-holder"></div>

    <!-- 你原有的 #app 保持不变 -->
    <div id="app">
      <!-- 核心：微信环境专属引导图遮罩 -->
      <div v-if="showWechatGuide" class="wechat-guide-mask" @click="closeGuide">
        <!-- 提示箭头 -->
        <div class="guide-arrow"></div>
        <!-- 提示文字 -->
        <div class="guide-content">
          <p>
            点击右上角
            <span style="font-weight: bold; color: #1989fa">···</span>
          </p>
          <p>
            选择
            <span style="font-weight: bold; text-decoration: underline"
              >在浏览器中打开</span
            >
          </p>
          <p style="font-size: 13px; color: #aaa; margin-top: 10px">
            （企业微信用户请选择在 Safari / 系统浏览器打开）
          </p>
        </div>
      </div>
      <keep-alive>
        <router-view
          v-if="$route.meta && $route.meta.keepAlive"
          :key="$route.name"
        ></router-view>
      </keep-alive>
      <router-view
        v-if="!($route.meta && $route.meta.keepAlive)"
        :key="$route.fullPath"
      ></router-view>
      <van-overlay :show="loading" :z-index="2000">
        <div class="global-loading">
          <van-loading vertical>加载中...</van-loading>
        </div>
      </van-overlay>
    </div>
  </div>
</template>

<script>
import { getQueryParamsFromUrl } from "@/common/index";
import { getAdList, getSysConfigByKey } from "@/api/index";
import { setLocalStorageData, getDeviceOS } from "@/common/index";
import { isMobile } from "@/utils/utils";
export default {
  name: "App",
  components: {},
  data() {
    return {};
  },
  async created() {
    if (process.env.VUE_APP_ENV === "productionApp") {
      this.$JSBridge.send("serviceType", { type: "1" });
      this.$JSBridge.listen("pushToken", (res) => {
        if (res.type == "1") {
          this.$store.commit("setToken", res.data.token);
          this.$store.commit("setUserInfo", { phone: res.data.phone });
          localStorage.setItem("phone", res.data.phone);
          this.$router.push({ name: "Home" });
        }
      });
      if (this.checkAndApplyTopOffset() == 0 && getDeviceOS() === "android") {
        this.initAndroidTopInset();
        this.$JSBridge.send("serviceType", { type: "11" });
      }
      if (this.checkAndApplyTopOffset() > 0) {
        let homeTopOffset = this.checkAndApplyTopOffset();
        const root = document.documentElement;
        root.style.setProperty("--home-top-offset", `${homeTopOffset}px`);
      }
    } else {
      const cachedToken = localStorage.getItem("token") || "";
      if (!this.$store.state.token && cachedToken) {
        this.$store.commit("setToken", cachedToken);
      }
      let queryParams = getQueryParamsFromUrl();
      if (queryParams.type && queryParams.type != "") {
        switch (queryParams.type) {
          case "1":
            this.$router.replace({ name: "appAgreement" });
            break;
          case "2":
            this.$store.commit("setChannelId", queryParams.channelId);
            this.$router.push({ name: "landingPage" });
            break;
          case "4":
            this.$router.replace({
              name: "loadAgreement",
              query: { ageType: queryParams.type },
            });
            break;
          case "5":
            this.$store.commit("setToken", queryParams.token);
            this.$router.replace({
              name: "Home"
            });
            break;
          case "6":
            this.$store.commit("setToken", queryParams.token);
            this.$router.replace({
              name: "orderList",
            });
            break;
          case "7":
            break;
          default:
            if (this.$route.path === "/") {
              this.$router.push({ name: "Login" });
            }
            break;
        }
      } else {
        if (this.$route.path === "/") {
          this.$router.push({ name: "Login" });
        }
      }
    }
  },
  async mounted() {
    if (getDeviceOS() === "android" && isMobile()) {
      // 全局监听所有输入框聚焦
      document.addEventListener("focusin", (e) => {
        const target = e.target;

        // 过滤出输入框和文本域
        if (target.tagName === "INPUT" || target.tagName === "TEXTAREA") {
          // 延迟 300ms 避开键盘弹出的动画时间，等待系统布局稳定
          setTimeout(() => {
            target.scrollIntoView({
              behavior: "smooth", // 平滑滚动动画
              block: "start", // 核心：把输入框滚到屏幕「正中间」，这样即便键盘再高也绝对遮不住
            });
          }, 0);
        }
      });
    }
    //获取广告
    let blackListAd = await getAdList({ pageNumber: 1, pageSize: 10, type: 2 });
    if (blackListAd.code === 2000) {
      this.$store.commit("setBlackListAd", blackListAd.data.recordList[0]);
    }
    let grayListAd = await getAdList({ pageNumber: 1, pageSize: 10, type: 3 });
    if (grayListAd.code === 2000) {
      this.$store.commit("setGrayListAd", grayListAd.data.recordList[0]);
    }
    let admissionAd = await getAdList({ pageNumber: 1, pageSize: 10, type: 4 });
    if (admissionAd.code === 2000) {
      this.$store.commit("setAdmissionAd", admissionAd.data.recordList[0]);
    }
    //获取放款模式
    let lendingModel = await getSysConfigByKey("loanDisbursementMethod");
    if (lendingModel.code === 2000) {
      setLocalStorageData("lendingModel", lendingModel.data.configValue);
    }
    //获取阅读协议配置
    let sysConfig = await getSysConfigByKey("agreementSigningConditions");
    if (sysConfig.code === 2000) {
      setLocalStorageData(
        "agreementSigningConditions",
        sysConfig.data.configValue,
      );
    }
  },
  methods: {
    checkAndApplyTopOffset() {
      // 1. 创建一个临时的 DOM 探测节点，用来测量 CSS 的 env(safe-area-inset-top)
      const probe = document.createElement("div");
      probe.style.position = "fixed";
      probe.style.top = "0";
      // 让其高度等于 CSS 的安全区顶部高度
      probe.style.height = "env(safe-area-inset-top, 0px)";
      probe.style.visibility = "hidden";
      probe.style.pointerEvents = "none";
      document.body.appendChild(probe);

      // 2. 获取该节点的实际像素高度
      const cssSafeTopPx = probe.clientHeight;

      // 移除探测节点，避免污染页面
      document.body.removeChild(probe);
      return cssSafeTopPx;
    },
    setNativeTopInsetPx(px) {
      const raw = Number(px);
      if (!Number.isFinite(raw)) return;
      const clamped = Math.max(0, Math.min(raw, 120));
      const value = `${clamped}px`;
      const root = document.documentElement;
      root.style.setProperty("--safe-top", value);
      root.style.setProperty("--app-top-offset", value);
      if (clamped > 0) {
        root.classList.add("native-top-inset");
      } else {
        root.classList.remove("native-top-inset");
      }
    },
    extractTopInset(payload) {
      if (payload === undefined || payload === null) return undefined;
      if (typeof payload === "number") return payload;
      if (typeof payload === "string") return Number(payload);
      const candidates = [
        payload.top,
        payload.statusBarHeight,
        payload.height,
        payload?.data?.top,
        payload?.data?.statusBarHeight,
        payload?.data?.height,
      ];
      for (const item of candidates) {
        const n = Number(item);
        if (Number.isFinite(n)) return n;
      }
      return undefined;
    },
    initAndroidTopInset() {
      if (process.env.VUE_APP_ENV !== "productionApp") return;
      if (getDeviceOS() !== "android") return;

      const queryParams = getQueryParamsFromUrl();
      const queryInset = this.extractTopInset({
        top:
          queryParams.safeTop ??
          queryParams.safeAreaTop ??
          queryParams.statusBarHeight,
      });
      if (Number.isFinite(queryInset) && queryInset > 0) {
        this.setNativeTopInsetPx(queryInset);
      }

      const applyFromPayload = (payload) => {
        const inset = this.extractTopInset(payload);
        if (Number.isFinite(inset) && inset >= 0) {
          this.setNativeTopInsetPx(inset);
        }
      };
      this.$JSBridge.listen("statusBarHeight", applyFromPayload);
    },
    closeGuide() {
      // 如果你允许用户点击遮罩层关闭引导（继续浏览 H5 低功能版），可保留此方法
      // 如果必须强制跳出，请直接注释掉这个方法，让遮罩不可关闭
      this.$store.commit("setShowWechatGuide", false);
      document.body.style.overflow = "";
    }
  },
  computed: {
    loading() {
      return this.$store.state.loading;
    },
    //是否展示过微信引导页面
    showWechatGuide() {
      return this.$store.state.showWechatGuide;
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  /* 给 TabBar 留出空间 */
  /* padding-bottom: 60px;  */
}
.global-loading {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* 默认隐藏这个占位层 */
.native-status-bar-holder {
  display: none;
}

/* 当处于 App 环境内、且被添加了 .native-top-inset 类名时激活 */
.native-top-inset .native-status-bar-holder {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  /* 完美对齐你之前定义的安卓偏移量 */
  height: var(--app-top-offset, 0px);
  /* 使用动态颜色变量，默认白色 */
  background-color: var(--status-bar-bg, #ffffff) !important;
  /* 确保它在最上层，不会被 H5 内部的其他 fixed 元素遮挡 */
  z-index: 99999;
}
/* 全屏引导遮罩层 */
.wechat-guide-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.85); /* 黑色半透明背景 */
  z-index: 999999; /* 确保压在所有 Vant 组件（包括弹窗、导航栏）的最上方 */
  display: flex;
  flex-direction: column;
  align-items: flex-end; /* 撑到右上角对齐 */
  padding: 20px;
  box-sizing: border-box;
}

/* 右上角提示文字与箭头容器 */
.guide-content {
  text-align: right;
  color: #ffffff;
  font-size: 16px;
  line-height: 1.6;
}

/* 动态闪烁的提示箭头（用 CSS 自带的三角绘制，无需切图） */
.guide-arrow {
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 15px solid #ffffff;
  transform: rotate(45deg); /* 旋转成指向右上角的箭头 */
  margin-right: 15px;
  margin-bottom: 15px;
  animation: bounce 1.5s infinite; /* 增加上下跳动动画，吸引注意 */
}

/* 跳动动画 */
@keyframes bounce {
  0%,
  100% {
    transform: rotate(45deg) translate(0, 0);
  }
  50% {
    transform: rotate(45deg) translate(5px, -5px);
  }
}
</style>
